export const claimReportTypeOption = [
  { value: "1", label: "Subscription - PDF" },
  { value: "2", label: "Utilization - PDF" },
  { value: "3", label: "Utilization - CSV" },
  { value: "4", label: "Subscription Per Claim - PDF" },
];
